<template>
  <div>
    <h5 class="mt-5 mb-3">Analys</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Ålder (år)</div>
        </div>
        <input type="number" step="1" class="form-control" :readonly="readonly" v-model.number="alder_ar" @input="emitInput">
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Senast målat med</div>
        </div>
        <select class="custom-select" :disabled="readonly" v-model="senast_malat_med" @change="emitInput">
          <option :value="undefined">- ingen vald -</option>
          <option>Lasyr</option>
          <option>Akrylatfärg</option>
          <option>Alkydoljefärg</option>
          <option>Akrylat/Alkyd</option>
          <option>Linoljefärg</option>
          <option>Slamfärg</option>
          <option>Silikat</option>
          <option>Silikonharts</option>
          <option>Silikat</option>
          <option>Akrylharts Kalk</option>
          <option>KC</option>
          <option>Ej målat</option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Målat (år)</div>
        </div>
        <input type="number" step="1" class="form-control" :readonly="readonly" v-model.number="malat_ar" @input="emitInput">
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Kulör NCS</div>
        </div>
        <input type="text" class="form-control" :readonly="readonly" v-model="kulor_ncs" @input="emitInput">
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Typ</div>
        </div>
        <select class="custom-select" :disabled="readonly" v-model="typ" @change="emitInput">
          <option :value="undefined">- ingen vald -</option>
          <option>Stående panel</option>
          <option>Liggande panel</option>
          <option>Mur</option>
          <option>Skiva</option>
          <option>Fönster</option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Material</div>
        </div>
        <select class="custom-select" :disabled="readonly" v-model="material" @change="emitInput">
          <option :value="undefined">- ingen vald -</option>
          <option>Gran</option>
          <option>Lärk</option>
          <option>Tryckt</option>
          <option>Ädelträ</option>
          <option>Kalkputs</option>
          <option>KC</option>
          <option>Betong</option>
          <option>Lättbetong</option>
          <option>Tegel</option>
          <option>Cementfiberskiva</option>
          <option>Alu</option>
          <option>Plast</option>
        </select>
      </div>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Yta</div>
        </div>
        <select class="custom-select" :disabled="readonly" v-model="yta" @change="emitInput">
          <option :value="undefined">- ingen vald -</option>
          <option>Slät</option>
          <option>Medel</option>
          <option>Grov</option>
        </select>
      </div>
    </div>

    <h5 class="mt-5 mb-3">Åtgärder Norr</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Kommentarer</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="kommentarer_norr" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Fuktkvot, Alg/mögel, Smuts, Flagning, Sprickor, Blåsor, Kritning, Gråträ, Rötskador</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Förbättringar</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="forbattringar_norr" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Lagning av fasad mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Rengöring</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="rengoring_norr" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Slipning, målartvätt mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Målning</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="malning_norr" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Olja, grundfärg, täckfärg mm.</small>
    </div>

    <h5 class="mt-5 mb-3">Åtgärder Syd</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Kommentarer</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="kommentarer_syd" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Fuktkvot, Alg/mögel, Smuts, Flagning, Sprickor, Blåsor, Kritning, Gråträ, Rötskador</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Förbättringar</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="forbattringar_syd" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Lagning av fasad mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Rengöring</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="rengoring_syd" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Slipning, målartvätt mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Målning</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="malning_syd" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Olja, grundfärg, täckfärg mm.</small>
    </div>

    <h5 class="mt-5 mb-3">Åtgärder Väst</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Kommentarer</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="kommentarer_vast" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Fuktkvot, Alg/mögel, Smuts, Flagning, Sprickor, Blåsor, Kritning, Gråträ, Rötskador</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Förbättringar</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="forbattringar_vast" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Lagning av fasad mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Rengöring</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="rengoring_vast" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Slipning, målartvätt mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Målning</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="malning_vast" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Olja, grundfärg, täckfärg mm.</small>
    </div>

    <h5 class="mt-5 mb-3">Åtgärder Öst</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Kommentarer</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="kommentarer_ost" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Fuktkvot, Alg/mögel, Smuts, Flagning, Sprickor, Blåsor, Kritning, Gråträ, Rötskador</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Förbättringar</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="forbattringar_ost" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Lagning av fasad mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Rengöring</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="rengoring_ost" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Slipning, målartvätt mm.</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Målning</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="malning_ost" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Olja, grundfärg, täckfärg mm.</small>
    </div>

    <h5 class="mt-5 mb-3">Åtgärder Övriga</h5>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Sockel</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="sockel" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Behöver sockeln målas eller åtgärdas?</small>
    </div>

    <div class="mb-3">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">Vindskivor mm</div>
        </div>
        <textarea class="form-control" :readonly="readonly" v-model="vindskivor_mm" @input="emitInput"></textarea>
      </div>

      <small v-if="showHelp" class="form-text text-muted">Behöver något mer målas eller åtgärdas?</small>
    </div>

  </div>
</template>

<style lang="scss" scoped>
textarea {
    min-height: 5.5rem;
}
</style>

<script setup lang="ts">
import { reactive, toRefs, watch } from "vue";

const fieldNames = [
    "alder_ar", "senast_malat_med", "malat_ar", "kulor_ncs", "typ", "material", "yta",
    "kommentarer_norr", "kommentarer_syd", "kommentarer_ost", "kommentarer_vast",
    "forbattringar_norr", "rengoring_norr", "malning_norr", "forbattringar_syd",
    "rengoring_syd", "malning_syd", "forbattringar_ost", "rengoring_ost", "malning_ost",
    "forbattringar_vast", "rengoring_vast", "malning_vast", "sockel", "vindskivor_mm",
] as const;
type FieldName = typeof fieldNames[number];
type FieldData = Partial<Record<FieldName, unknown>>;
interface Props { modelValue?: FieldData; readonly?: boolean; showHelp?: boolean; }
const props = withDefaults(defineProps<Props>(), { modelValue: () => ({}), readonly: false, showHelp: true });
const emit = defineEmits<{ (event: "update:modelValue", value: FieldData): void }>();
const state = reactive<FieldData>(Object.fromEntries(fieldNames.map((name) => [name, undefined])));
const { alder_ar, senast_malat_med, malat_ar, kulor_ncs, typ, material, yta,
    kommentarer_norr, kommentarer_syd, kommentarer_ost, kommentarer_vast,
    forbattringar_norr, rengoring_norr, malning_norr, forbattringar_syd, rengoring_syd,
    malning_syd, forbattringar_ost, rengoring_ost, malning_ost, forbattringar_vast,
    rengoring_vast, malning_vast, sockel, vindskivor_mm } = toRefs(state);
function currentValue(): FieldData { return props.modelValue; }
function captureValue(): void { const value = currentValue(); fieldNames.forEach((name) => { state[name] = value?.[name]; }); }
function emitInput(): void { const value = Object.fromEntries(fieldNames.map((name) => [name, state[name]])) as FieldData; emit("update:modelValue", value); }
watch(currentValue, captureValue, { immediate: true });
</script>
